// Call-prep details shown in the contact page header

export type CallFlag = 'top-customer' | 'dont-call' | 'not-worth-chasing' | 'none';

export const callFlagOptions: {
  value: CallFlag;
  label: string;
}[] = [{
  value: 'top-customer',
  label: 'Top customer'
}, {
  value: 'dont-call',
  label: "Don't call"
}, {
  value: 'not-worth-chasing',
  label: 'Not worth chasing'
}, {
  value: 'none',
  label: 'No flag'
}];

export const contactCallInfo = {
  callFlag: 'top-customer' as CallFlag,
  lastContacted: {
    date: '2026-09-12',
    method: 'Voicemail',
    by: 'Jude'
  }
};
